export const CARRIER = 'carrier';
export const SELECT_ALL = 'selectAll';
export const DIMENSIONS = ['length', 'width', 'height'];

export const CARRIER_PACKAGES_TABLE = {
  headers: ['name'],
};

export const CUSTOM_PACKAGES_TABLE = {
  header: ['title', 'add'],
  headers: ['name', 'length', 'width', 'height', 'tareWeight', 'maxWeight'],
  actions: ['edit', 'delete'],
  actionThemeMap: {
    delete: 'danger',
  },
};

export const CUSTOM_PACKAGE_DEFAULTS = {
  carrierId: null,
  dimensions: {},
  tareWeight: null,
  maxWeight: null,
  weightUnit: null,
  isCustom: true,
  isHidden: false,
  name: '',
  packageTypeId: null,
};

export enum MODALS {
  Add = 'add',
  Edit = 'edit',
  Delete = 'delete',
}
